<style lang="scss" scoped>
  .last-action {
    width: 100%;
    overflow: hidden;

    @include media(max, lg) {
      overflow: visible;
    }

    .mobile-image {
      text-align: center;
      @include media(max, md) {
        img {
          width: 100%;
          max-width: 320px;
        }
      }
    }

    @include media(max, lg) {
      background-size: contain;
      background-repeat: no-repeat;

      .gradient {
        z-index: 5;
        position: relative;
        height: 222px;
        width: 100%;
        margin-top: -225px;
        background-image: linear-gradient(to bottom, transparent, $dark-indigo-three);
      }
    }

    .wrapper {
      padding-top: 100px;
      height: 650px;
      display: flex;
      position: relative;

      .helper {
        .link-text {
          text-decoration: underline;
          cursor: pointer;
          color: inherit;
        }
      }

      @include margin-x(auto);
      width: map_get($container, lg);

      @include media(max, md) {
        width: 100%;
        @include padding-x($gutter/2);
        height: auto;
        padding-top: 0;
      }

      &.wrapper-mobile {
        display: flex;
        flex-direction: column;
        padding: 0;
        height: auto;
        width: 100%;
        max-width: map_get($container, md);

        .controls {
          width: 390px;
          margin: 0 auto;
          text-align: center;

          .button {
            width: 100%;

            svg {
              flex-shrink: 0;
              margin-left: 10px;
            }
          }

          @include media(max, lg) {
            max-width: 350px;

            .button {
              font-weight: 500;
              font-size: 17px;
              width: 100%;

              &.download a {
                padding-left: 25px;
                padding-right: 25px;
              }
            }
          }
        }

        .mobile-content {
          padding: 30px 40px 60px;
          background: linear-gradient(180deg, #000000 35.38%, rgba(0, 0, 0, 0) 100%), #292E34;
          border-radius: 6px;

          & > .text {
            max-width: 100%;
            font-size: 26px;
            line-height: 34px;
            text-align: center;
            color: #F5F5F7;
            margin-bottom: 30px;

            @include media(max, md) {
              font-size: 22px;
              line-height: 30px;
            }
          }

          @include media(max, md) {
            padding: 30px 0;
            background: none;
          }
        }
      }

      .content {
        flex: 1 1 445px;
        max-width: 445px;
        height: 458px;
        margin-right: 70px;
        z-index: 10;
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: relative;
        padding: 0 0 60px 45px;

        @include media(max, lg) {
          max-width: 100%;
        }

        @include media(max, md) {
          margin-top: 0;
          max-width: 100%;
          text-align: center;
        }

        .description {
          margin-top: 22px;
          font-size: 18px;
          line-height: 1.6;
          color: rgba(white, .76);

          @include media(max, lg) {
            margin-top: 16px;
            font-size: 16px;
          }
        }

        .controls {
          margin-top: 40px;
          max-width: 390px;
          text-align: center;

          .button {
            width: auto;

            svg {
              flex-shrink: 0;
              margin-left: 10px;
            }
          }

          @include media(max, lg) {
            text-align: center;
            margin-top: 24px;
            width: 100%;
          }
        }
      }

      .mobile-content .helper,
      .content .helper {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 16px;
        color: rgba(white, .5);
        font-size: 15px;

        .text {
          display: flex;
          align-items: center;
          color: rgba(white, .5);

          .icon {
            margin-right: 8px;
          }
        }
      }

      .mobile-content .helper {
        font-size: 13px;
      }

      @mixin from-to($w, $h, $top, $left) {
        top: $top + 0px;
        left: $left + 0px;
        width: $w + 0px;
        height: $h + 0px;

        @include media(max, lg) {
          top: $top * .5 + 0px;
          left: $left * .5 + 0px;
          width: $w * .5 + 0px;
          height: $h * .5 + 0px;
        }

        transform: scale(.6);
        opacity: .3;

        &.to {
          transform: scale(1);
          opacity: 1;
        }
      }

      .images {
        position: relative;
        flex: 1 1 505px;
        max-width: 505px;
        height: 458px;

        .gradient {
          position: absolute;
          top: -150px;
          left: -100px;
          width: 967px;
          height: 685px;
          background: 50% 50%/cover no-repeat;

          @include media(max, lg) {
            margin-top: 32px;
            margin-left: 29px;
            height: 213px;
            background-size: contain;
          }

          [dir=rtl] & {
            left: auto;
            right: -100px;
          }
        }

        .image {
          transition: 700ms;
          position: absolute;
          border-radius: 5px;
          background-repeat: no-repeat;
          background-size: cover;
          background-position: center center;

          &.image-1 {
            @include from-to(526, 328, 98, 260);
            z-index: 5;
          }

          &.image-2 {
            @include from-to(284, 295, 0, 484);
          }

          &.image-3 {
            @include from-to(194, 210, 167, 55);
            z-index: 4;
          }

          &.image-4 {
            @include from-to(250, 127, -40, 208);
          }

          &.image-5 {
            @include from-to(229, 135, 20, 20);
          }

          [dir=rtl] & {
            &.image-1 {
              @include from-to(526, 328, 98, -250);
            }

            &.image-2 {
              @include from-to(284, 295, 0, -200);
            }

            &.image-3 {
              @include from-to(194, 210, 167, 150);
            }

            &.image-4 {
              @include from-to(250, 127, -40, 70);
            }

            &.image-5 {
              @include from-to(229, 135, 20, 148);
            }
          }
        }
      }
    }
  }
</style>

<template>
  <div
    class="last-action"
    ref="container">
    <template v-if="appIsTablet || appIsMobile">
      <div class="wrapper wrapper-mobile">
        <div class="mobile-image">
          <img  v-if="appIsTablet"
                :src="`${baseUrl}images/blocks/last-action/last-actions-sm.jpg`"/>
          <img v-if="appIsMobile"
               :src="`${baseUrl}images/blocks/last-action/last-actions-sm.jpg`" width="320"/>
        </div>
        <div class="mobile-content">
          <div class="text">{{$t('textTablet')}}</div>
          <div class="controls" v-if="isMobile()">
            <btn
              :href="btnUrl"
              :size="'lg'"
              class="fw-semi-bold fs-18">
              <template v-if="!isLinkGameCenter">{{$t('buttonGCMobile')}}</template>
              <template v-else>{{$t('buttonMobile')}}</template>
            </btn>
          </div>
          <div class="controls" v-else>
            <btn
              download
              v-on:click="downloadGameCenter"
              :size="appIsSmall ? 'lg' : 'xl'"
              class="fw-semi-bold"
              :class="{
                'fs-18': appIsSmall,
                'fs-24': appIsLarge
              }"
              block>
              <template v-if="!isLinkGameCenter">{{$t('buttonGC')}}</template>
              <template v-else>{{$t('button', {platform: isMac ? 'MAC' : 'Windows'})}}
                <icon v-if="isMac" name="mac"/>
                <icon v-else name="windows"/>
              </template>
            </btn>
            <div class="helper" v-if='isRu'>
              <div v-if="isMac" class="text">{{$t('clientAvailable')}}&nbsp;<a class="link-text" download v-on:click="downloadGameCenterForWindows">Windows</a></div>
              <div v-else class="text">{{$t('clientAvailable')}}&nbsp;<a class="link-text" download v-on:click="downloadGameCenterForMacOs">macOS</a></div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="wrapper">
        <div class="content">
          <div class="title_section" v-html="$t('title')"></div>
          <div class="description" v-html="$t('text')"></div>
          <div class="controls">
            <btn
              v-on:click="downloadGameCenter"
              download
              :size="'xl'"
              class="fw-semi-bold fs-22 download"
              block>
              <a :href=gcDownloadUrl onclick="return false;" download="">
                <template v-if="!isLinkGameCenter">{{$t('buttonGC')}}</template>
                <template v-else>{{$t('button', {platform: isMac ? 'MAC' : 'Windows'})}}
                  <icon v-if="isMac" name="mac"/>
                  <icon v-else name="windows"/>
                </template>
              </a>
            </btn>
            <div class="helper" v-if='isRu'>
              <div v-if="isMac" class="text">{{$t('clientAvailable')}}&nbsp;<a class="link-text" download v-on:click="downloadGameCenterForWindows">Windows</a></div>
              <div v-else class="text">{{$t('clientAvailable')}}&nbsp;<a class="link-text" download v-on:click="downloadGameCenterForMacOs">macOS</a></div>
            </div>
          </div>
        </div>
        <div class="images">
          <div class="gradient" :style="{backgroundImage:`url(${baseUrl}images/blocks/last-action/gradient.svg`}">
          </div>
          <div
            v-for="(image, index) in images"
            :key="image"
            class="image"
            :class="{[`image-${index + 1}`]: true, to: imagesTo}"
            :style="{backgroundImage: `url(${baseUrl}images/blocks/last-action/${image})`}">
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>

import { buildDownloadUrl } from '@utils/helpers';

export default {
  name: 'LastAction',
  i18n: {
    messages: {
      ru: {
        title: 'Все преимущества в&nbsp;одной&nbsp;программе',
        text: 'Играйте, общайтесь и создавайте трансляции с Игровым центром.',
        button: 'Загрузить {platform} версию',
        buttonGC: 'Загрузить Игровой центр',
        buttonMobile: 'Перейти',
        clientAvailable: 'Клиент также доступен для',
        buttonGCMobile: 'Перейти в Игровой центр',
        textTablet: 'Откройте игровой мир, наполненный сражениями и приключениями!',
      },
      en: {
        title: 'Everything you need in one platform',
        text: 'Play, chat, and stream with GameCenter',
        button: 'Download {platform} version',
        buttonGC: 'Download GameCenter',
        buttonMobile: 'Visit',
        clientAvailable: 'Client is also available for',
        buttonGCMobile: 'Visit GameCenter',
        textTablet: 'Unlock the world of gaming, filled with battles and adventures!',
      },
      de: {
        title: 'Das Beste <br>in einem Programm vereint',
        text: 'Spiele, chatte und streame mit dem GameCenter.',
        button: '{platform}-Version herunterladen',
        buttonGC: 'GameCenter herunterladen',
        buttonMobile: 'Besuchen',
        clientAvailable: 'Der Client ist auch verfügbar für',
        buttonGCMobile: 'GameCenter besuchen',
        textTablet: 'Entdecke eine neue Gaming-Welt voller Kämpfe und Abenteuer',
      },
      fr: {
        title: 'Tout le meilleur <br>en un seul programme',
        text: 'Jouer, discutez et streamez avec le GameCenter de.',
        button: 'Télécharger la version {platform}',
        buttonGC: 'Télécharger le GameCenter',
        buttonMobile: 'Visiter',
        clientAvailable: 'Le client est également disponible sur',
        buttonGCMobile: 'Visiter le GameCenter',
        textTablet: 'Découvrez un monde de gaming rempli de batailles et d\'aventures',
      },
      es: {
        title: 'Lo mejor en un solo programa',
        text: 'Juega, habla y retransmite con GameCenter.',
        button: 'Descargar la versión de {platform}',
        buttonGC: 'Descargar el GameCenter',
        buttonGCMobile: 'Visitar la tienda',
        clientAvailable: 'El cliente también está disponible en',
        buttonMobile: 'Visitar',
        textTablet: 'Descubre un mundo de videojuegos lleno de batallas y aventuras',
      },

      tr: {
        title: 'Tüm en iyiler bir programda',
        text: 'GameCenter ile oyna, konuş ve yayın yap.',
        button: '{platform} sürümünü indir',
        buttonGC: 'GameCenter\'ı indir',
        buttonGCMobile: 'Mağaza\'yı ziyaret et',
        clientAvailable: 'İstemci için de mevcuttur',
        buttonMobile: 'Ziyaret et',
        textTablet: 'Oyun dünyasını keşfet savaş ve macera doolu',
      },

      pl: {
        title: 'Wszystko co najlepsze<br> w jednym programie',
        text: 'Graj, rozmawiaj i transmituj za pomocą Centrum gier.',
        button: 'Pobierz wersję {platform}',
        buttonGC: 'Pobierz Centrum gier',
        buttonGCMobile: 'Odwiedź GameCenter',
        clientAvailable: 'Klient jest również dostępny na system',
        buttonMobile: 'Odwiedź',
        textTablet: 'Odkryj świat gier pełen bitew i przygód',
      },
      ar: {
        title: 'كل ما تحتاجه على منصة واحدة',
        text: 'اللعب، والدردشة، والبث باستخدام مركز ألعاب',
        button: 'تنزيل نسخة {platform}',
        buttonGC: 'تنزيل مركز الألعاب',
        buttonMobile: 'زيارة',
        clientAvailable: 'اللعبة متوفرة أيضًا على',
        buttonGCMobile: 'زيارة مركز الألعاب',
        textTablet: 'افتح عالم الألعاب، الحافل بالمعارك والمغامرات!',
      },
    },
  },
  props: {
    scrollTop: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      images: [
        '1.png',
        '2.jpg',
        '3.png',
        '4.jpg',
        '5.jpg',
      ],

      containerTop: 0,
      isRu: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.containerTop = window.pageYOffset + this.$refs.container.getBoundingClientRect().top;
    }, 500);
    setTimeout(() => {
      // eslint-disable-next-line no-underscore-dangle
      this.isRu = !!window.__GEMS && window.__GEMS.country_id ? window.__GEMS.country_id === '188' : this.getCurrentLang === 'ru';
    }, 800);
  },
  methods: {
    downloadGameCenter() {
      const url = buildDownloadUrl();
      // eslint-disable-next-line
      return window.EVA.gc.detectAndDownload('', url)
    },
    downloadGameCenterForMacOs() {
      const domain = 'https://static.gc.vkplay.ru';
      const url = `${domain}/gcmac/distrib/GameCenterShowcase.dmg`;

      // eslint-disable-next-line
      return window.EVA.gc.detectAndDownload('', url)
    },
    downloadGameCenterForWindows() {
      const domain = 'https://static.gc.vkplay.ru';
      const url = `${domain}/VKPlayLoader.exe`;

      // eslint-disable-next-line
      return window.EVA.gc.detectAndDownload('', url)
    },
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
  },
  computed: {
    imagesTo() {
      return this.scrollTop && this.scrollTop + window.innerHeight > this.containerTop + 100;
    },
    btnUrl() {
      return '//vkplay.ru/';
    },
    gcDownloadUrl() {
      if (navigator.appVersion.indexOf('Mac') !== -1) {
        const domain = 'https://static.gc.vkplay.ru';
        return `${domain}/gcmac/distrib/GameCenterShowcase.dmg`;
      }
      return 'https://static.gc.vkplay.ru/VKPlayLoader.exe';
    },
  },
};

</script>
